import { FragmentsViewSchema } from '../../models/fragments';
import { API_PREFIX, defineEndpoint } from '../endpoint';

/** What the station shows: absorbed fragments, the body's room, loadouts (MAGIC-FRAGMENT). */
export const getFragments = defineEndpoint({
  method: 'GET',
  path: `${API_PREFIX}/fragments`,
  access: 'session',
  response: FragmentsViewSchema,
});
